import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { BackButton, Button, Input, Title, Collapsible } from '../../../components/UI/ComponentsUI';
import StockService from '../../../services/StockService';
import { onValueChange, validateInputsRequired } from "../../../utils/handleChangeHooks";
import { closeCollapsible, translate } from '../../../utils/util';
import ListUI from '../../../components/UI/ListUI';

const SearchShed = (props) => {
    const [filterSearch, setFilterSearch] = useState({
        partNumber: props.filter?.partNumber || ''
    });

    const [data, setData] = useState([]);

    const onChange = (event) => {
        onValueChange(event, filterSearch, setFilterSearch);
    };

    const search = () => {
        if (validateInputsRequired('formInput')) {

            props.GetPartNumberShed(filterSearch.partNumber, (data) => {
                if (data) {
                    setData(data);
                    closeCollapsible("collapsibleBalance");
                }
                else {
                    setData([]);
                }
            });
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="row" style={{ marginTop: '5px' }}>
                <Title icon="mdi mdi-magnify" label={translate('shed-search', 'stock')} />
            </div>
            <div className="container" >
                <Collapsible
                    id="collapsibleBalance"
                    header={translate('stock:filter')}
                    body={
                        <>
                            <div id="formInput" className="row no-margin-bottom">
                                <div className="row">
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="partNumber"
                                            name='partNumber'
                                            label={translate('stock:partnumber')}
                                            type="text"
                                            numericonly="true"
                                            maxLength={11}
                                            required
                                            defaultValue={filterSearch.partNumber || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px', paddingBottom: '10px' }}>
                                <Button
                                    full="true"
                                    className="col s6 btn-principal"
                                    text={translate('general:search')}
                                    onClick={search}
                                />
                            </div>

                        </>
                    }
                />

            </div>
            <div className="container-fluid" style={{ marginTop: '0px', paddingBlockEnd: '50px' }}>
                <ListUI
                    data={data.map((item, index) => {
                        return (
                            <div
                                className="row"
                                style={{ color: 'black', display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                                key={`oi-${index}`}
                            >
                                <div className="row" style={{ marginBottom: '0px', paddingLeft: '5px' }}>
                                    <span className="title sixth-text-color right col s12">{translate('part-number', 'physical-confirmation')}: {item.partNumberCode}</span>
                                    <span className="title sixth-text-color right col s12">{translate('description', 'stock')}: {item.partNumberDescription}</span>
                                    <span className="title sixth-text-color right col s12">{translate('shed', 'resource')} : {item.shedCode}</span>
                                    <span className="title sixth-text-color right col s12">{translate('title', 'area')} : {item.area || ''}</span>
                                </div>
                            </div>
                        );
                    })}
                />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        GetPartNumberShed: (code, callback) => {
            dispatch(StockService.GetPartNumberShed(code, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SearchShed));